// ذخیرهٔ صورتحساب سهم تخفیف کلی را در ستون تخفیف ردیف‌ها می‌نویسد (Backend از ۱۴۰۵/۰۴/۱۴)؛ پس ردیف
// «سایر تخفیف‌های کلی» صورتحساب ذخیره‌شده دیگر پولی برای پخش‌کردن ندارد. فرم تا پیش از این با هر بازشدن
// آن را دوباره روی ردیف‌ها می‌نشاند و هر ذخیره، تخفیف را به‌اندازهٔ همان ردیف بیشتر می‌کرد.

type DiscountRow = {price?: number}
type InvoiceRow = {price?: number; discount?: number; totalDiscount?: number}

const sumOf = <T>(rows: T[], read: (row: T) => number | undefined) =>
  rows.reduce((sum, row) => sum + (read(row) || 0), 0)

/** آنچه فرم هنگام بازکردن صورتحساب ذخیره‌شده باید از تخفیف‌های کلی آن بداند. */
export const getLoadedGeneralDiscount = (rows: InvoiceRow[], discounts: DiscountRow[]) => {
  const sum = sumOf(discounts, (discount) => discount.price)
  // سهمی که روی totalDiscount ردیف‌ها نیست: یا در ستون تخفیف ردیف‌ها نوشته شده یا هرگز اعمال نشده است.
  const alreadyInRows = Math.max(0, sum - sumOf(rows, (row) => row.totalDiscount))
  const rowDiscounts = sumOf(rows, (row) => row.discount)
  return {
    sum,
    alreadyInRows,
    // ستون تخفیفِ کمتر از این سهم آن را در خود ندارد (ردیف پس از آن با دست عوض شده)؛ چیزی برای پس‌دادن نیست.
    inDiscountColumn: rowDiscounts >= alreadyInRows ? alreadyInRows : 0,
    // مبلغ پس از تخفیف ردیف‌ها، پایهٔ تخفیف درصدی
    base: sumOf(rows, (row) => row.price) - rowDiscounts,
  }
}

/**
 * آنچه پس از تغییر ردیف‌های تخفیف کلی باید با مبلغ ردیف‌ها بشود: مبلغ تازه روی ردیف‌ها پخش می‌شود، و
 * مبلغی که حذف یا کم شده و در ستون تخفیف نوشته شده بود، از همان ستون برمی‌گردد.
 */
export const getGeneralDiscountChange = <T extends DiscountRow>(
  discounts: T[],
  alreadyInRows: number,
  inDiscountColumn: number
): {
  discounts: DiscountRow[]
  takeBack: number
  alreadyInRows: number
  inDiscountColumn: number
} => {
  const sum = sumOf(discounts, (discount) => discount.price)
  if (sum < alreadyInRows) {
    const takeBack = Math.min(inDiscountColumn, alreadyInRows - sum)
    return {
      discounts: [],
      takeBack,
      alreadyInRows: sum,
      inDiscountColumn: inDiscountColumn - takeBack,
    }
  }

  const remaining = sum - alreadyInRows
  return {
    discounts: alreadyInRows <= 0 ? discounts : remaining > 0 ? [{price: remaining}] : [],
    takeBack: 0,
    alreadyInRows,
    inDiscountColumn,
  }
}
